import { EditFilled } from "@ant-design/icons";
import { InputNumber, Modal, Space, Typography } from "antd";
import { doc, updateDoc } from "firebase/firestore";
import { useState } from "react";
import { db } from "../../../firebase/config";
import { Notification } from "../../Notification";

const { Link } = Typography;

const initialState = null;

export function UnconfirmedGroupPricePopup(props) {
   const [isModalOpen, setIsModalOpen] = useState(initialState);
   const [profitability, setProfitability] = useState(initialState);

   const showModal = async () => {
      setIsModalOpen(true);
      setProfitability(props.value.profitability);
   };

   const handleCancel = () => {
      setIsModalOpen(false);
      setProfitability(initialState);
   };

   const updateData = async (e) => {
      e.preventDefault();
      const ref = doc(db, "clientGroups", props.value.id);
      await updateDoc(ref, {
         profitability: profitability,
      })
         .then(() => {
            setIsModalOpen(true);
            Notification("success", "Updated!", "Your data has been updated");
         })
         .then(() => {
            setIsModalOpen(false);
            setProfitability(initialState);
         })
         .catch((err) => {
            Notification("error", "Login Error", err.message);
         });
   };
   return (
      <>
         <Space>
            <Link onClick={showModal}>
               {props.text} % <EditFilled />
            </Link>
         </Space>

         <Modal width={700} title={"Selected Group : " + props.value.groupName} open={isModalOpen} onOk={updateData} onCancel={handleCancel}>
            <Space>
               <InputNumber
                  addonBefore="Profitability :"
                  style={{ width: "100%" }}
                  value={profitability}
                  addonAfter="%"
                  onChange={(value) => setProfitability(value)}
               />
            </Space>
         </Modal>
      </>
   );
}
